import $ from "jquery";

// Workaround for CKEditor 5's ridiculous media embed solution...
const $mediaEmbedElements = $("figure.media>oembed[url]");
$mediaEmbedElements.each(function () {
  const $this = $(this);
  const url = $this.attr('url');
  const urlParts = url.split(".");
  const extension = urlParts[urlParts.length - 1];
  let newElement;

  if (url.indexOf("youtube.com") > -1 || url.indexOf("youtu.be") > -1) {
    const youtubeVideoCode = url.split('?v=')[1];
    // paste some BS5 embed code in place of the Figure tag
    $this.parent().replaceWith(`
      <div class="embed-responsive embed-responsive-16by9">
        <iframe src="https://www.youtube.com/embed/${youtubeVideoCode}?rel=0" class="embed-responsive-item" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>`
    );
  } else if (extension === "mp4") {
    newElement = `
      <div class="bg-black clearfix focus-container-height js-video-wrapper p-1">
        <video class="js-media w-100 bg-black mb-4" controls>
          <source src="${url}" type="video/mp4">
          Your browser does not support the video element.
        </video>
        <div class="focus-height">
          <div class="p-2 float-right ">
              <button type='button' class="js-video-rate-control btn btn-sm btn-light" data-rate="0.5">
                  0.50
              </button>
              <button type='button' class="js-video-rate-control btn btn-sm btn-light" data-rate="0.75">
                  0.75
              </button>
              <button type='button' class="js-video-rate-control btn btn-sm btn-light gradient-secondary text-white" data-rate="1.0">
                  1.00
              </button>
              <button type='button' class="js-video-rate-control btn btn-sm btn-light" data-rate="1.25">
                  1.25
              </button>
              <button type='button' class="js-video-rate-control btn btn-sm btn-light" data-rate="1.50">
                  1.50
              </button>
              <button type='button' class="js-video-rate-control btn btn-sm btn-light" data-rate="2.00">
                  2.00
              </button>
          </div>
        </div>
      </div>`
  } else if (extension === "pdf") {
    newElement = `<a class="btn btn-primary my-1" href="${url}" target="_blank">Download PDF</a>`;
  } else if (["mp3", "wav", "m4a"].includes(extension)) {
    const audioElement = document.createElement("audio");
    audioElement.setAttribute("controlsList", "nodownload");
    audioElement.setAttribute("controls", undefined);
    audioElement.src = url;
    audioElement.innerHTML = "Your browser does not support the audio element";
    newElement = audioElement;
  }
  if (newElement) $this.parent().replaceWith(newElement);
});

const $videoRateControls = $(".js-video-rate-control");
$videoRateControls.on("click", function (event) {
  event.preventDefault();
  const $this = $(this);
  const rate = $this.attr("data-rate");
  const $videoElement = $this.closest('.js-video-wrapper').find('video')
  if ($videoElement.length)
    $videoElement[0].playbackRate = parseFloat(rate);

  $videoRateControls.each(function () {
    const $this = $(this);
    if ($this.hasClass("text-white")) {
      $this.removeClass("text-white gradient-secondary");
    }
  });

  $this.addClass("text-white gradient-secondary");
});